/**
 * non-frequent, never-buying, frequent
 */
export enum FrequencyFlag {
  NonFrequent = 'non-frequent',
  NeverBuying = 'never-buying',
  Frequent = 'frequent',
}

export enum Rank {
  Top50 = 'Top_50',
  Top100 = 'Top_100',
  Top150 = 'Top_150',
  Top200 = 'Top_200',
  Top250 = 'Top_250',
  Top500 = 'Top_500',
  Top1000 = 'Top_1000',
  OverTop1000 = 'over_Top_1000',
  None = '-',
  CallThisMonth = 'Call this month',
}

export type EngagementPrediction = {
  created: Date
  createdBy: string
  modified: Date
  modifiedBy: string
  entryId: string
  partnerId: string
  partnerName: string
  flagPc: string
  flagPrint: string
  flagSupplies: string
  flagAll: string
  hpOrganization: string
  country: string
  salesRep: string
  salesRepMailId: string
  hpOrgRank: string
  countryRank: string
  agentRank: string
  timestampForPred: Date
  month: string
  quarter: string
}
